import { useEffect } from "react";
import { ICONS } from "../constants";
import "./SelectContributor.css";
import { useRef } from "react";
import VenmoBadge from "./VenmoBadge";
import ZelleBadge from "./ZelleBadge";

export default function SelectContributor(props) {
  const { contributors, contributorId, setContributorId, editMode } = props;
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!contributorId && contributors && contributors.length > 0) {
      setContributorId(contributors[0].id);
    }
  }, [contributors, contributorId, setContributorId]);

  const scrollToView = ()=>{
    dropdownRef.current.focus();
  };

  const selected = contributors.find((c) => c.id === contributorId);

  return (
    <div className="dropdown">
      <button
        type="button"
        className={editMode? "btn btn-outline-secondary dropdown-toggle select-contributor-button"
        : "btn btn-outline-secondary select-contributor-button"}
        data-bs-toggle="dropdown"
        onClick={scrollToView}
        disabled={editMode? false : true}
      >
        <span className="d-inline-flex align-items-center gap-2">
          <span>{ICONS[selected?.icon]}</span>
          <span className="text-truncate">{selected?.name}</span>
          <span className="d-inline-flex align-items-center gap-1">
            <VenmoBadge username={selected?.venmoUsername} />
            <ZelleBadge
              zelleUsername={selected?.zelleUsername}
              zelleRecipientName={selected?.zelleRecipientName}
            />
          </span>
        </span>
      </button>
      <div
        className="dropdown-menu as-dropdown-menu"
        onClick={(e) => {
          e.preventDefault();
          const btn = e.target.closest("button");
          const nextValue = btn?.getAttribute("value");
          if (nextValue) setContributorId(nextValue);
        }}
      >
        {contributors.map((c) => (
          <button
            type="button"
            ref={contributorId === c.id ? dropdownRef:null}
            className={`select-contributor-button dropdown-item text-center ${
              contributorId === c.id ? "active" : ""
            }`}
            key={c.id}
            value={c.id}
          >
            <span className="d-inline-flex align-items-center gap-2">
              <span>{ICONS[c.icon]}</span>
              <span className="text-truncate">{c.name}</span>
              <span className="d-inline-flex align-items-center gap-1">
                <VenmoBadge username={c.venmoUsername} />
                <ZelleBadge
                  zelleUsername={c.zelleUsername}
                  zelleRecipientName={c.zelleRecipientName}
                />
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
